export const CURRENCY_COP = 0;
export const CURRENCY_USD = 1;

export function formatCurrencyAmount(amount, currency = CURRENCY_COP) {
  const isUsd = currency === CURRENCY_USD;
  return new Intl.NumberFormat(isUsd ? "en-US" : "es-CO", {
    style: "currency",
    currency: isUsd ? "USD" : "COP",
    minimumFractionDigits: isUsd ? 2 : 0,
    maximumFractionDigits: isUsd ? 2 : 0,
  }).format(amount || 0);
}

export function getCurrencyLabel(currency = CURRENCY_COP) {
  return currency === CURRENCY_USD ? "USD" : "COP";
}

export function transformCurrencyData(currencyData) {
  return currencyData.map((item) => ({
    value: item.id,
    label: item.siglas.trim(),
  }));
}
